import React from "react";
import { Button, Form, InputField } from "components/form";
import { passwordPattern } from "helpers/patterns";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useVerifyEmailToken } from "pages/informations/info.service";
import { client } from "helpers/client";
import { useAuthContext } from "store/auth";

function ResetPasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [, dispatch] = useAuthContext();
  const { token } = useParams();
  const { preregisterData } = useVerifyEmailToken("/login");

  async function handleResetPassword(data: any) {
    const { response } = await client("/auth/changePassword", {
      data: {
        customerId: preregisterData?.id,
        password: data.password,
        token,
      },
    });

    if (response) {
      dispatch({ type: "logout" });
      navigate("/login");
    }
  }

  if (preregisterData?.expiryDate)
    return (
      <Navigate
        to="/info/link-expired"
        state={{ actionType: "resetPassword" }}
      />
    );

  return (
    <div className="forgotPassword">
      <div className="login">
        <div className="row">
          <div className="col-xl-8 col-lg-10 mx-auto">
            <div className="row">
              <div className="col-lg-6">
                <h1 className="title">
                  {t("signup:rest")}
                  <span> {t("signup:password")}</span>
                </h1>
              </div>

              <Form
                className="col-lg-6"
                onSubmit={handleResetPassword}
                defaultValues={{ email: "" }}
              >
                {({ watch }) => {
                  return (
                    <>
                      <InputField
                        id="password"
                        type="password"
                        label={t("signup:password")}
                        rules={{
                          required:"errors:required",
                          pattern: {
                            value: passwordPattern,
                            message: "errors:invalidFormat",
                          },
                        }}
                      />
                      <InputField
                        id="confirmPassword"
                        type="password"
                        label={t("signup:confirm") + t("signup:password")}
                        rules={{
                          required: "errors:required",
                          pattern: {
                            value: new RegExp(`^${watch("password")}$`),
                            message: "errors:passwordMismatch",
                          },
                        }}
                      />
                      <Button className="btn-blue">
                        {t("signup:change")}
                      </Button>
                    </>
                  );
                }}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
